import Vue from "vue";

export const leadsService = {
  list,
  listSource,
  getById,
  getHistoricById,
  create,
  update,
  destroy,
  unarchive,
  getEventsById,
  comment,
  exportLeads,
  createPayment,
  getPaymentById
};

function list(params) {
  return Vue.axios.get("v2/admin/leads", { params });
}

function listSource(params) {
  return Vue.axios.get("v2/admin/lead_sources", { params });
}

function getById(id) {
  return Vue.axios.get(`v1/leads/${id}`);
}

function getHistoricById(id) {
  return Vue.axios.get(`v1/leads/${id}/comments`);
}

function create(payload) {
  return Vue.axios.post("v1/leads", payload);
}

function update(payload) {
  return Vue.axios.patch(`v1/leads/${payload.id}`, payload);
}

function destroy(id) {
  return Vue.axios.delete(`v1/leads/${id}`);
}

function unarchive(payload) {
  const formData = new FormData();

  if (payload.id) {
    formData.append("next_phase", payload.next_phase);
    return Vue.axios.post(`v1/leads/${payload.id}/unarchive`, formData);
  } else {
    formData.append("next_phase", payload.next_phase);
    payload.lead_ids.forEach(id => {
      formData.append("lead_ids[]", id);
    });
    return Vue.axios.post("v2/admin/leads/unarchive", formData);
  }
}

function getEventsById(payload) {
  const params = {
    page: payload.page,
    items: payload.items,
    start_date: payload.start_date,
    end_date: payload.end_date
  };
  return Vue.axios.get(`v1/leads/${payload.leadId}/events`, { params });
}

function comment(payload) {
  const params = { description: payload.description };
  return Vue.axios.post(`v1/leads/${payload.leadId}/comments`, params);
}

function exportLeads(params) {
  return Vue.axios.get(`v2/admin/reports/export_leads.xlsx`, {
    responseType: "blob",
    params: params
  });
}

function createPayment(params) {
  const formData = new FormData();

  formData.set("lead_id", params.leadId);
  formData.set("payment_date", params.date);
  formData.set("consultant_id", params.userId);
  formData.set("description", params.description);
  formData.set("photo", params.file);

  return Vue.axios.post("v2/admin/leads/payments", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

function getPaymentById(id) {
  const params = { user_id: id };
  return Vue.axios.get(`v2/admin/consultants/bank_accounts`, { params });
}
